import { render } from "./ForeignEmployeesTable.vue?vue&type=template&id=710218af&scoped=true"
import script from "./ForeignEmployeesTable.vue?vue&type=script&lang=js"
export * from "./ForeignEmployeesTable.vue?vue&type=script&lang=js"

import "./ForeignEmployeesTable.vue?vue&type=style&index=0&id=710218af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710218af"]])

export default __exports__